import React from 'react';

import { Box, getCSSVariable } from '@opendoor/bricks-next';
import { motion } from 'framer-motion';

import type { MegaNavItem } from '../../types';
import { MobileSubMenuBackButton } from './MobileSubMenuBackButton';
import { MobileSubMenuSection } from './MobileSubMenuSection';

interface MobileMenuSubMenuProps {
  megaNavData: MegaNavItem[];
  openSubMenu: string;
  navList: any;
  onBack: () => void;
  footer?: React.ReactNode;
}

const subMenuVariants = {
  hidden: {
    x: '100%',
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
    },
  },
  visible: {
    x: 0,
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
    },
  },
};

export const MobileMenuSubMenu: React.FC<MobileMenuSubMenuProps> = ({
  megaNavData,
  openSubMenu,
  navList,
  onBack,
  footer,
}) => {
  const currentItem = megaNavData.find((item) => item.name === openSubMenu);

  if (!currentItem) return null;

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="hidden"
      variants={subMenuVariants}
      style={{
        overflowY: 'auto',
        overflowX: 'hidden',
        background: getCSSVariable('$backgroundPrimary', 'color'),
      }}
    >
      <Box borderTopWidth={1} borderColor="$borderPrimary" />
      <MobileSubMenuBackButton onClick={onBack} />
      {currentItem.sections?.map((section, sectionIdx) => (
        <MobileSubMenuSection
          key={sectionIdx}
          section={section}
          parentName={openSubMenu}
          navList={navList}
        />
      ))}
      {footer}
    </motion.div>
  );
};
